// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2qsKn","selects":"Documents_selects__2pEtf"};